<template>
  <div id="printable-table">
    <b-table-simple hover small responsive>
      <b-thead head-variant="dark">
        <b-tr class="text-center">
          <b-th>Produto</b-th>
          <b-th>Quantidade</b-th>
          <b-th>Preço unitário</b-th>
          <b-th>Total</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(item, index) in order.items">
          <b-tr
            :key="`${order._id}-${item._id}-${index}`"
            :style="{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }"
          >
            <b-th>
              {{ productName(item) }}
            </b-th>
            <b-td class="text-center">
              {{ item.quantity }}
            </b-td>
            <b-td class="text-center">
              {{ productPrice(item) | currency }}
            </b-td>
            <b-td class="text-center">
              <strong>
                {{ (productPrice(item) * item.quantity) | currency }}
              </strong>
            </b-td>
          </b-tr>
          <b-tr v-if="item.note" :key="`${item._id}-${index}-note`">
            <b-td colspan="4">
              <strong>Observação:</strong> {{ item.note }}
            </b-td>
          </b-tr>
          <template v-for="(group, index) in categories(item.complements)">
            <b-tr :key="`${order._id}-${item._id}-${group}-${index}`">
              <b-td class="text-center">
                {{
                  complementGroup(group)
                    ? complementGroup(group).title
                    : ""
                }}
              </b-td>
              <b-td></b-td>
              <b-td></b-td>
              <b-td></b-td>
            </b-tr>
            <template
              v-for="(complement, index) in complements(
                group,
                item.complements
              )"
            >
              <b-tr
                :key="
                  `${order._id}-${item._id}-${group}-${complement._id}-${index}`
                "
              >
                <b-td class="text-right">
                  {{ complement.code ? `${complement.code} - ` : "" }}
                  {{ complement.title }}
                </b-td>
                <b-td class="text-center">
                  {{ complement.quantity }}
                </b-td>
                <b-td class="text-center">
                  {{ complement.price | currency }}
                </b-td>
                <b-td class="text-center">
                  {{
                    (complement.price * complement.quantity * item.quantity)
                      | currency
                  }}
                </b-td>
              </b-tr>
            </template>
          </template>

          <template v-if="productHasOffer(order, item)">
            <b-tr :key="`${order._id}-product-offer-${item._id}-${index}`">
              <b-td class="text-center">
                <strong>Descontos</strong>
              </b-td>
              <b-td></b-td>
              <b-td></b-td>
              <b-td></b-td>
            </b-tr>
            <template
              v-for="(discount, dIndex) in productDiscount(
                order.offers,
                item.relatedOffer.offerId
              )"
            >
              <b-tr
                :key="
                  `${order._id}-product-offer-${item._id}-${index}-${discount._id}-${dIndex}`
                "
              >
                <b-td class="text-right">
                  {{ discount.title }}
                </b-td>
                <b-td class="text-center">
                  {{ item.quantity }}
                </b-td>
                <b-td class="text-center">
                  -
                  {{ productDiscountValue(item, discount) | currency }}
                </b-td>
                <b-td class="text-center">
                  -
                  {{
                    (productDiscountValue(item, discount) * item.quantity)
                      | currency
                  }}
                </b-td>
              </b-tr>
            </template>
          </template>
        </template>
      </b-tbody>
    </b-table-simple>

    <br />

    <b-table-simple hover small responsive>
      <b-thead head-variant="dark">
        <b-tr class="text-center">
          <b-th colspan="4">Resumo do pedido</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-if="order.additionalInfo">
          <b-td>Informações adicionais (posição ou placa)</b-td>
          <b-td class="text-right">
            <strong>
              {{ order.additionalInfo }}
            </strong>
          </b-td>
        </b-tr>
        <b-tr v-if="isColmeia">
          <b-td>Código de revendedor</b-td>
          <b-td class="text-right">
            <strong>
              {{ order.sellerCode }}
            </strong>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Subtotal</b-td>
          <b-td class="text-right">
            <strong>
              {{ subtotal(order) | currency }}
            </strong>
          </b-td>
        </b-tr>
        <b-tr
          v-if="
            order.deliveryFee ||
              (order.loyalty &&
                order.loyalty.rewards &&
                order.loyalty.rewards.deliveryFeeExemption) ||
              (order.coupon &&
                order.coupon.rewards &&
                order.coupon.rewards.deliveryFeeExemption)
          "
        >
          <b-td>Taxa de entrega</b-td>
          <b-td class="text-right">{{ deliveryFee(order) }}</b-td>
        </b-tr>
        <template v-if="order.discount || order.loyalty || order.coupon">
          <template v-if="order.loyalty">
            <b-tr>
              <b-td>Fidelidade</b-td>
              <b-td class="text-right">
                {{ order.loyalty.title }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>Pontos resgatados</b-td>
              <b-td class="text-right">
                {{
                  order.loyalty.triggers && order.loyalty.triggers.pointsCost
                    ? order.loyalty.triggers.pointsCost
                    : "pontos inválidos"
                }}
              </b-td>
            </b-tr>
          </template>
          <b-tr v-if="order.coupon">
            <b-td>Cupom</b-td>
            <b-td class="text-right">
              {{
                order.coupon.triggers && order.coupon.triggers.coupon
                  ? order.coupon.triggers.coupon.code
                  : "cupom inválido"
              }}
            </b-td>
          </b-tr>
          <b-tr v-if="order.discount">
            <b-td>Desconto</b-td>
            <b-td class="text-right">
              - {{ order.discount && (order.deliveryFee ||
              (order.loyalty &&
                order.loyalty.rewards &&
                order.loyalty.rewards.deliveryFeeExemption) ||
              (order.coupon &&
                order.coupon.rewards &&
                order.coupon.rewards.deliveryFeeExemption)) ? ((order.subtotal - order.total) + order.deliveryFee) : orderDiscount(order) | currency }}
            </b-td>
          </b-tr>
        </template>
        <b-tr>
          <b-td>Total</b-td>
          <b-td class="text-right">
            <strong>
              {{ (order.amount && order.discount ? order.total : total(order) - orderDiscount(order)) | currency }}
            </strong>
          </b-td>
        </b-tr>
        <template v-if="order.change && order.change > 0">
          <b-tr>
            <b-td>Pediu troco para</b-td>
            <b-td class="text-right">
              {{ order.change | currency }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>Levar troco de</b-td>
            <b-td class="text-right">
              {{
                (order.change - (order.amount && order.discount ? order.subtotal - (order.subtotal - order.total) : total(order) - orderDiscount(order)))
                  | currency
              }}
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import { getComplementGroup } from "@/helpers/queries";
import { getAccessToken } from "@/helpers/storage";
import { discountValue, productDiscount } from "@/helpers/discount";
import { subtotal, orderDiscount, total } from "@/helpers/order";
import { deliveryFee } from "@/helpers/textFormatter";
import { fullPrice, totalPrice } from "@/helpers/product";

export default {
  name: "ordertable",
  props: {
    order: { type: Object, required: true },
  },
  mounted() {
    if (this.order.sellerCode) {
      this.isColmeia = true;
    }
  },
  data() {
    return { queried: new Set(), isColmeia: false };
  },
  computed: {
    feathers() {
      return this.$FeathersVuex.api;
    },
    accessToken: () => getAccessToken(),
  },
  methods: {
    toCurrency(value) {
      return this.$options.filters.currency(value);
    },
    categories(items) {
      let groups = [];

      items.forEach((item) => groups.push(item.complementGroup));

      const set = new Set(groups);

      groups = [...set];

      return groups;
    },
    complements(groupId, items) {
      let result = items.filter((item) => item.complementGroup === groupId);

      return result;
    },
    productDiscountValue(item, offer) {
      return discountValue(this, fullPrice(item), offer);
    },
    productDiscount(offers, offerId) {
      return productDiscount(offers, offerId);
    },
    deliveryFee(order) {
      return deliveryFee(order);
    },
    productPrice(item) {
      return this.isColmeia ? item.price : item.originalPrice;
    },
    price(item) {
      return this.isColmeia ? item.price : fullPrice(item);
    },
    totalPrice(item) {
      return totalPrice(item);
    },
    complementGroup(id) {
      const complement = this.feathers.ComplementGroup.getFromStore(id);

      if (complement) {
        return complement;
      } else {
        if (!this.queried.has(id)) {
          this.queried.add(id);

          getComplementGroup(this.feathers, this.accessToken, id);
        }

        return null;
      }
    },
    productHasOffer(order, item) {
      return (
        order.offers &&
        item.relatedOffer &&
        item.relatedOffer.discountType &&
        item.relatedOffer.discountType.type
      );
    },
    orderDiscount(order) {
      return orderDiscount(this, order);
    },
    total(order) {
      return this.isColmeia ? order.total : total(this, order);
    },
    subtotal(order) {
      return this.isColmeia ? order.subtotal : subtotal(this, order);
    },
    productName(item) {
      let result;

      if (this.isColmeia) {
        const sub = item.subproduct;

        result = `${sub.barcode} - ${sub.name}`;
      } else {
        const prefix = item.code ? `${item.code} - ` : "";

        result = `${prefix}${item.title}`;
      }

      return result;
    },
  },
};
</script>
